<template>

    <div class="layout__container">

        <div class="layout__margin-25-0">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Sales Insight</el-breadcrumb-item>
                <el-breadcrumb-item><span class="text__colour-teal">Customer Status</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <h3 class="text__align-center text__colour-teal">Customer Status</h3>

        <div class="layout__position-center">
            <div class="layout__position-left layout__width-100">
                <CustomerStatusSearch v-bind:searchParams="searchParams" v-bind:sales="sales"></CustomerStatusSearch>
            </div>

            <div class="insights-table layout__width-100 layout__position-left">
                <el-table class="el-table__09vh layout__height-400px layout__scrolling__right" :data="sales" style="width: 100%;" show-summary :summary-method="getSummaries" @sort-change="handleSortOrderChange" 
                v-loading.fullscreen.lock="loading" element-loading-text="Loading..." element-loading-background="rgba(79, 147, 168, 0.2)" empty-text="No data has been returned for the selected dates">
                    <el-table-column prop="orderYear" label="Year" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="orderMonth" label="Month" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getMonthName">
                    </el-table-column>
                    <el-table-column prop="new" label="New Customers" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                        <template slot-scope="scope">
                            {{ getAmount(scope.row.new) }}&nbsp;&nbsp;&nbsp;<el-button class="button-teal" icon="el-icon-download" size="mini" :loading="loadingsNew[scope.$index]" @click="csv(scope.$index, scope.column, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="active" label="Active Customers" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                        <template slot-scope="scope">
                            {{ getAmount(scope.row.active) }}&nbsp;&nbsp;&nbsp;<el-button class="button-teal" icon="el-icon-download" size="mini" :loading="loadingsActive[scope.$index]" @click="csv(scope.$index, scope.column, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lapsed" label="Lapsed Customers" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                        <template slot-scope="scope">
                            {{ getAmount(scope.row.lapsed) }}&nbsp;&nbsp;&nbsp;<el-button class="button-teal" icon="el-icon-download" size="mini" :loading="loadingsLapsed[scope.$index]" @click="csv(scope.$index, scope.column, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="reactivated" label="Reactivated Customers" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                        <template slot-scope="scope">
                            {{ getAmount(scope.row.reactivated) }}&nbsp;&nbsp;&nbsp;<el-button class="button-teal" icon="el-icon-download" size="mini" :loading="loadingsReactivated[scope.$index]" @click="csv(scope.$index, scope.column, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <canvas id="customer-status-chart" class="component__chart-main component__chart-float-center component__chart-padding-30px"></canvas>
    </div>

</template>

<script>

    import Chart from 'chart.js';
    import moment from 'moment';
    import Axios from 'axios';
    import download from 'downloadjs';
    import CustomerStatusSearch from '@/components/insights/CustomerStatusSearch';
    import barChartBase from '../../mixins/bar-chart-base.js';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {sortJsonArrayHelper} from '@/mixins/sort-json-array.js';
 
    export default {
        name: "sales",
        mixins: [axios, csvDownloadHelper, dataFormatter, sortJsonArrayHelper],
        components: {
            CustomerStatusSearch
        },
        props: {
            view: ''
        },
        data() {
            return {
                selectedIndex: -1,
                selectedYear: '',
                selectedMonth: '',
                selectedCustomerType: '',
                selectedColumn: 0,
                selectedRow: 0,
                sales: [],
                loading: false,
                loadingsNew: {},
                loadingsActive: {},
                loadingsLapsed: {},
                loadingsReactivated: {},
                myChart: Object,
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                searchParams: {
                    salesSource: "ANY PRODUCT",
                    salesSourceId: null,
                    salesStatus: 'ORDERED',
                    salesDateRange: [new Date().toLocaleDateString('en-GB'), new Date().toLocaleDateString('en-GB')],
                    salesFreeText: ''
                },
            }
        },
        created() {
            this.isUserAuthorised();

            this.initLoaders();
        },
        methods: {
            initLoaders: function () {
                let self = this;
                this.sales.forEach(function (v, i) {
	                this.$set(self.loadingsNew, i, false);
	                this.$set(self.loadingsActive, i, false);
	                this.$set(self.loadingsLapsed, i, false);
	                this.$set(self.loadingsReactivated, i, false);
                });
            },
            getMonthName(row, column) {
                let monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
                return monthNames[row.orderMonth - 1];
            },
            getCurrencyAmount(row, column, cellValue) {
                if (typeof cellValue === 'undefined') {
                    return '£0'
                } else {
                    return '£' + cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            },
            getAmount(cellValue) {
                if (typeof cellValue === 'undefined') {
                    return '0'
                } else {
                    return this.returnWithCommas(cellValue.toString());
                }
            },
            handleSizeChange(val) {
                console.log(`${val} items per page`);

                this.pagination = val
                console.log(this.start)
                this.end = this.pagination;
                console.log(this.end)
            },
            handleCurrentChange(val) {
                console.log(`current page: ${val}`);

                this.start = (val - 1) * this.pagination + 1;
                console.log(this.start)
                this.end = val * this.pagination;
                console.log(this.end)
            },
            chartCompleted() {
                console.log("chartCompleted");
                this.downloadUrl = this.myChart.toBase64Image();
                console.log("this.downloadUrl=" + this.downloadUrl);
            },
            downloadChart() {
                download(this.downloadUrl);
            },
            setLoading(property, index, value) {
                switch(property) {
                case 'new':
                    this.$set(this.loadingsNew, index, value);
                    break;
                case 'active':
                    this.$set(this.loadingsActive, index, value);
                    break;
                case 'lapsed':
                    this.$set(this.loadingsLapsed, index, value);
                    break;
                case 'reactivated':
                    this.$set(this.loadingsReactivated, index, value);
                    break;
                }
            },
            handleSortOrderChange(sortProps) {
                console.log('prop: ' + sortProps.prop);
                console.log('order: ' + sortProps.order);

                this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    var noTotalCols = ["Month", "Year"];
                    if (noTotalCols.indexOf(column.label) >= 0) {
                        sums[index] = '';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = this.returnWithCommas(values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0).toString());
                    } else {
                        sums[index] = '';
                    }
                });

                return sums;
            },
            csv(index, column, row) {
                this.selectedIndex = index;
                this.selectedYear = row.orderYear;
                this.selectedMonth = row.orderMonth;
                this.selectedCustomerType = column.property;

                console.log('this.selectedIndex:' + this.selectedIndex);
                console.log('this.selectedYear:' + this.selectedYear);
                console.log('this.selectedMonth:' + this.selectedMonth);
                console.log('this.selectedCustomerType:' + this.selectedCustomerType);

                console.log('before')
                console.log(this.searchParams)

                let searchTerms = Object.assign({}, this.searchParams)
                console.log('searchTerms')
                console.log(searchTerms)

                console.log('after search is copied')
                console.log(this.searchParams)

                console.log('after search is copied - new object')
                console.log(searchTerms)

                var customerStatusDetails = [],
                    endpoint = this.serviceRouteUrl + '/api/v1/insights/order/CustomerStatusDetails?customerType=' + this.selectedCustomerType + '&month=' + this.selectedMonth + '&year=' + this.selectedYear;

                console.log(endpoint)

                this.setLoading(this.selectedCustomerType, this.selectedIndex, true);

                Axios.get(endpoint, this.returnHeaderUsingToken())
                .then(response => {
                    if (this.selectedCustomerType == 'lapsed') {
                        const fields = [
                            {label: 'Branch', value: (row, field) => row.branch.replace(' ', '')},
                            {label: 'Territory', value: 'territory'},
                            {label: 'Last Order Date', value: (row, field) => moment(row.last_Order_Date).format('DD/MM/YYYY h:mm:ss a')},
                        ];

                        this.downloadCsv(this.exportDate, fields, response.data.customerStatusDetails)
                    } else {
                        const fields = [
                            {label: 'Branch', value: (row, field) => row.branch.replace(' ', '')},
                            {label: 'Territory', value: 'territory'},
                            {label: 'No Of Orders', value: 'no_of_Orders'},
                            {label: 'Total Sales', value: 'total_Sales'}
                        ];

                        this.downloadCsv(this.exportDate, fields, response.data.customerStatusDetails)
                    }

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.setLoading(this.selectedCustomerType, this.selectedIndex, false);
                    });
                })
                .catch(error => {
                    if (error.response) {
                        this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                    }

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.setLoading(this.selectedCustomerType, this.selectedIndex, false);
                    });
                })
            }
        }
    };
</script>